import ContentType from './contentType';

const ORGANIZATION        = 1;
const HTML                = 2;
const MENU_INTERACTIVES   = 3;
const LINKS               = 4;
const DISCURSIVE_EXERCISE = 5;
const FORUM               = 6;
const WEBCONFERENCE       = 7;
const EXERCISE            = 8;
const LTI                 = 9;
const AVALIA              = 10;
const H5P                 = 11;
const SCORM               = 12;

const getCategoryTypeNameById = (id) => {
  return {
    [ORGANIZATION]        : 'ORGANIZATION',
    [HTML]                : 'HTML',
    [MENU_INTERACTIVES]   : 'MENU_INTERACTIVES',
    [LINKS]               : 'LINKS',
    [DISCURSIVE_EXERCISE] : 'DISCURSIVE_EXERCISE',
    [FORUM]               : 'FORUM',
    [WEBCONFERENCE]       : 'WEBCONFERENCE',
    [EXERCISE]            : 'EXERCISE',
    [LTI]                 : 'LTI',
    [AVALIA]              : 'AVALIA',
    [H5P]                 : 'H5P',
    [SCORM]               : 'SCORM'
  }[id];
};

const getCategoryI18NKeyById = id => {
  return {
    [ORGANIZATION]        : 'categoryTypes.organization',
    [HTML]                : 'categoryTypes.html',
    [MENU_INTERACTIVES]   : 'categoryTypes.interactive',
    [LINKS]               : 'categoryTypes.links',
    [DISCURSIVE_EXERCISE] : 'categoryTypes.task',
    [FORUM]               : 'categoryTypes.forum',
    [WEBCONFERENCE]       : 'categoryTypes.webConference',
    [EXERCISE]            : 'categoryTypes.quiz',
    [LTI]                 : 'categoryTypes.lti',
    [AVALIA]              : 'categoryTypes.avalia',
    [H5P]                 : 'categoryTypes.h5p',
    [SCORM]               : 'categoryTypes.scorm'
  }[id];
};

const getEditModalEventById = (id) => {
  return {
    [ORGANIZATION]        : 'changeIsOpenModalContentPage',
    [HTML]                : 'changeIsOpenModalContentHtml',
    [MENU_INTERACTIVES]   : 'changeIsOpenModalContentInteractive',
    [LINKS]               : 'changeIsOpenModalContentLinkGroup',
    [DISCURSIVE_EXERCISE] : 'changeIsOpenModalContentTask',
    [FORUM]               : 'changeIsOpenModalContentForum',
    [WEBCONFERENCE]       : 'changeIsOpenModalContentWebconference',
    [EXERCISE]            : 'changeIsOpenModalContentQuiz',
    [LTI]                 : 'changeIsOpenModalContentLti',
    [AVALIA]              : 'changeIsOpenModalContentAvalia',
    [H5P]                 : 'changeIsOpenModalContentH5p',
    [SCORM]               : 'changeIsOpenModalContentScorm'
  }[id];
};

const getCategoryPermissionAlias = (id, action) => {
  return {
    [ORGANIZATION]        : null,
    [HTML]                : `resources_html_${action}`,
    [MENU_INTERACTIVES]   : `resources_embedded_link_${action}`,
    [LINKS]               : `resources_link_group_${action}`,
    [DISCURSIVE_EXERCISE] : `resources_task_${action}`,
    [FORUM]               : `resources_forum_${action}`,
    [WEBCONFERENCE]       : `resources_webconference_${action}`,
    [EXERCISE]            : `resources_quiz_${action}`,
    [LTI]                 : `resources_lti_${action}`,
    [AVALIA]              : `resources_avalia_activity_${action}`,
    [H5P]                 : `resources_h5p_${action}`,
    [SCORM]               : `resources_scorm_${action}`
  }[id];
};

const getDefaultTopicType = (id) => {
  return {
    [ORGANIZATION]        : null,
    [HTML]                : ContentType.HTML,
    [MENU_INTERACTIVES]   : ContentType.EMBEDDED_LINK,
    [LINKS]               : ContentType.LINK_GROUP,
    [DISCURSIVE_EXERCISE] : ContentType.TASK,
    [FORUM]               : ContentType.FORUM,
    [WEBCONFERENCE]       : ContentType.WEBCONFERENCE,
    [EXERCISE]            : ContentType.QUIZ,
    [LTI]                 : ContentType.LTI,
    [AVALIA]              : ContentType.AVALIA,
    [H5P]                 : ContentType.H5P,
    [SCORM]               : ContentType.SCORM
  }[id];
};

const activityCategories = [
  DISCURSIVE_EXERCISE,
  FORUM,
  EXERCISE,
  LTI,
  AVALIA,
  H5P,
  SCORM
];

const categoriesWithProgressTracking = [
  LTI,
  EXERCISE,
  WEBCONFERENCE,
  FORUM,
  DISCURSIVE_EXERCISE,
  AVALIA,
  SCORM
];

const markProgressInSidebarRender = [
  LINKS,
  HTML
];

export default {
  getCategoryTypeNameById,
  getEditModalEventById,
  getCategoryPermissionAlias,
  getDefaultTopicType,
  ORGANIZATION,
  MENU_INTERACTIVES,
  HTML,
  LINKS,
  DISCURSIVE_EXERCISE,
  FORUM,
  WEBCONFERENCE,
  EXERCISE,
  LTI,
  AVALIA,
  H5P,
  SCORM,
  activityCategories,
  categoriesWithProgressTracking,
  markProgressInSidebarRender,
  getCategoryI18NKeyById
};
